<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card>
        <div slot="header" class="clearfix">
          <span>体力赠送</span>
        </div>
        <sendCardStat ref="spinStat" :k="'num'" />
      </el-card>

      <el-card>
        <div slot="header" class="clearfix">
          <span>卡片赠送</span>
        </div>
        <sendCardStat ref="cardStat" :k="'num'" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getSendSpinStat } from '@/api/user/user_info'
// import sendSpinStat from '@/views/config/send-stat/components/send-spin-stat.vue'
import sendCardStat from '@/views/config/send-stat/components/send-card-stat.vue'
import { getLastDates, scientificFormat } from '@/utils'
export default {
  name: 'SpinStat',
  components: {
    sendCardStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 1
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables()
    this.getSendCard()
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables()
      this.getSendCard()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      this.queryParams.type = 2
      getSendSpinStat(this.queryParams).then(res => {
        this.$refs.spinStat.refresh(res.data)
      })
    },
    getSendCard() {
      this.queryParams.type = 3
      getSendSpinStat(this.queryParams).then(res => {
        this.$refs.cardStat.refresh(res.data)
      })
    }
  }
}
</script>

<style scoped>
</style>
